// extracted by mini-css-extract-plugin
module.exports = {"table":"AdminUsersPage_table__1BGxW","inactive":"AdminUsersPage_inactive__23sDt","btn":"AdminUsersPage_btn___v2bc","addBtn":"AdminUsersPage_addBtn__wh-xu"};